/* eslint-disable no-prototype-builtins */
import ScrollLocker from './scrollLocker';
export default {
  bind: function bind(el, binding) {
    if (binding.modifiers.skip) {
      // eslint-disable-next-line no-param-reassign
      el.dataset.skipLocker = true;
    }
  },
  inserted: function inserted(el, binding) {
    if (binding.modifiers.skip) {
      return;
    }

    var isLock = binding.hasOwnProperty('value') ? binding.value === true : true;

    if (isLock) {
      ScrollLocker.lock(el);
    }
  },
  componentUpdated: function componentUpdated(el, binding) {
    if (binding.modifiers.skip) {
      return;
    }

    var isLock = binding.hasOwnProperty('value') ? binding.value === true : true;

    if (isLock) {
      ScrollLocker.lock(el);
    } else {
      ScrollLocker.unlock(el);
    }
  },
  unbind: function unbind(el, binding) {
    if (binding.modifiers.skip) {
      return;
    }

    ScrollLocker.unlock(el);
  }
};